<template>
  <div>
    <div v-if="!show_historico">
      <div class="row">
        <div class="col">
          <h5 class="font-weight-bold">Condições Habitacionais</h5>
        </div>
        <div class="col text-right">
          <p class="font-weight-light font-italic">
            <a
              href="#"
              class="router-link-exact-active active"
              @click="show_historico = true"
            >
              <i class="fas fa-history"></i> Histórico
            </a>
          </p>
        </div>
      </div>
      <div class="row mt-3">
        <form-select
          v-model="domicilio.local"
          grid="6"
          label="Características do local onde está situado o domicílio"
          :itens="$root.arrays.local"
        />

        <form-select
          v-model="domicilio.tipo_residencia"
          grid="6"
          label="Tipo de residência"
          :itens="$root.arrays.tipo_residencia"
        />

        <form-input
          type="number"
          v-model="domicilio.quant_comodos"
          grid="6"
          label="Quantos cômodos tem seu domicílio?"
        />

        <form-input
          v-model="domicilio.quant_comodos_dormitorio"
          grid="6"
          type="number"
          label="Qual o nº de cômodos utilizados como dormitório?"
        />

        <form-input
          v-model="domicilio.numero_pessoas_dormitorio"
          grid="6"
          type="number"
          label="Quanto é nº de pessoas do domicílio dividido pelo nº de dormitórios?"
        />

        <form-select
          v-model="domicilio.material_piso"
          grid="6"
          label="Material predominante no piso?"
          :itens="$root.arrays.material_piso"
        />

        <form-select
          v-model="domicilio.material_paredes"
          grid="6"
          label="Material predominante na construção das paredes externas?"
          :itens="$root.arrays.material_paredes"
        />

        <form-select
          v-model="domicilio.agua_canalizada"
          grid="6"
          label="Possui água canalizada para, pelo menos, um cômodo?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="domicilio.forma_abastecimento_agua"
          grid="6"
          label="Forma de abastecimento de água utilizada no seu domicílio?"
          :itens="$root.arrays.forma_abastecimento_agua"
        />

        <form-select
          v-model="domicilio.banheiro"
          grid="6"
          label="Na propriedade existe banheiro ou sanitário?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="domicilio.forma_escoamento_sanitario"
          grid="6"
          label="De que forma é feito o escoamento do banheiro ou sanitário?"
          :itens="$root.arrays.forma_escoamento_sanitario"
        />

        <form-select
          v-model="domicilio.destino_lixo"
          grid="6"
          label="Forma de coleta do lixo?"
          :itens="$root.arrays.destino_lixo"
        />

        <form-select
          v-model="domicilio.iluminacao"
          grid="6"
          label="Forma de iluminação utilizada no seu domicílio?"
          :itens="$root.arrays.iluminacao"
        />

        <form-select
          v-model="domicilio.calcamento_pavimentacao"
          grid="6"
          label="Existe calçamento/pavimentação em frente ao seu domicílio?"
          :itens="$root.arrays.calcamento_pavimentacao"
        />

        <form-select
          v-model="domicilio.acessibilidade_locomocao"
          grid="6"
          label="Possui acessibilidade para pessoas com dificuldade de locomoção?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="domicilio.area_risco"
          grid="6"
          label="Domicílio localizado em área de risco de desabamento ou alagamento?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="domicilio.area_dificl_acesso"
          grid="6"
          label="Domicílio localizado em área de difícil acesso geográfico?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="domicilio.area_conflito_violencia"
          grid="6"
          label="Domicílio localizado em área com forte presença de conflito/violência?"
          :itens="$root.arrays.pergunta"
        />

        <form-textarea
          v-model="domicilio.observacoes_domicilio"
          grid="12"
          label="Outras observações referentes ao diagnóstico das condições habitacionais da família"
        />
      </div>

      <div class="row pt-4 px-2 d-flex justify-content-end">
        <form-toggle
          grid="9"
          class="d-flex justify-content-end"
          mt="0"
          v-model="item.cadastrarHabitacao"
          label="	Cadastrar uma nova condição habitacional?"
        />
        <button class="btn btn-success btn-submit" data-style="zoom-in" @click="submit">
          <i class="mdi mdi-content-save"></i>
          {{ $t("Salvar") }}
        </button>
      </div>
    </div>
    <div v-else>
      <Historico @voltar="show_historico = false" :familia-id="$route.params.id" />
    </div>
  </div>
</template>
<script>
import Historico from "../historico/Habitacao";
export default {
  components: { Historico },
  props: ["item"],
  data() {
    return {
      domicilio: {},
      show_historico: false,
    };
  },
  mounted() {
    if (this.item.domicilio != null) {
      this.domicilio = this.item.domicilio;
    }
  },
  methods: {
    submit() {
      this.item.domicilio = this.domicilio;
      this.$emit("submit");
    },
  },
};
</script>
